/* mt-case-display.js — Tab 切换 + 多图弹窗逻辑 */
(function () {
  'use strict';

  var TAB_QUERY_KEY = 'tab';
  var SECTION_SCROLL_OFFSET = 16;

  function isCaseStudiesPage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === '/pages/case-studies';
  }

  function setActivePanel(sectionEl, target) {
    if (!sectionEl || !target) return;

    var tabs = sectionEl.querySelectorAll('.mt-case-display__tab');
    var panels = sectionEl.querySelectorAll('.mt-case-display__panel');

    tabs.forEach(function (tab) {
      var isActive = tab.dataset.target === target;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.panel === target);
    });
  }

  function getTransitionState(sectionEl) {
    if (!sectionEl.__mcdTransitionState) {
      sectionEl.__mcdTransitionState = {
        activeTarget: null
      };
    }

    return sectionEl.__mcdTransitionState;
  }

  function getHeaderOffset() {
    var raw = window.getComputedStyle(document.body).getPropertyValue('--header-group-height');
    var parsed = parseFloat(raw);
    return isNaN(parsed) ? 0 : parsed;
  }

  function normalizeTabSlug(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function getRequestedSlug() {
    var url = new URL(window.location.href);
    var querySlug = normalizeTabSlug(url.searchParams.get(TAB_QUERY_KEY));
    if (querySlug) return querySlug;

    return normalizeTabSlug(window.location.hash.replace(/^#/, ''));
  }

  function updateUrlForSlug(slug, historyMode) {
    var normalizedSlug = normalizeTabSlug(slug);
    if (!normalizedSlug) return;
    if (!isCaseStudiesPage()) return;

    var url = new URL(window.location.href);
    if (normalizeTabSlug(url.searchParams.get(TAB_QUERY_KEY)) === normalizedSlug && !url.hash) return;

    url.searchParams.set(TAB_QUERY_KEY, normalizedSlug);
    url.hash = '';
    var method = historyMode === 'push' ? 'pushState' : 'replaceState';
    window.history[method]({}, '', url.pathname + url.search);
  }

  function scrollSectionIntoView(sectionEl) {
    if (!sectionEl) return;

    var top = sectionEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - SECTION_SCROLL_OFFSET;
    window.scrollTo({
      top: Math.max(top, 0),
      behavior: 'auto'
    });
  }

  function findTabBySlug(sectionEl, slug) {
    if (!sectionEl || !slug) return null;
    return sectionEl.querySelector('.mt-case-display__tab[data-tab-slug="' + slug + '"]');
  }

  function findSlugByTarget(sectionEl, target) {
    if (!sectionEl || !target) return '';

    var tab = sectionEl.querySelector('.mt-case-display__tab[data-target="' + target + '"]');
    return tab ? normalizeTabSlug(tab.dataset.tabSlug) : '';
  }

  function getCurrentTarget(sectionEl) {
    var activeTab = sectionEl.querySelector('.mt-case-display__tab.is-active');
    if (activeTab && activeTab.dataset.target) return activeTab.dataset.target;

    var firstTab = sectionEl.querySelector('.mt-case-display__tab');
    return firstTab ? firstTab.dataset.target : null;
  }

  function syncTransitionTarget(sectionEl, fallbackToFirst) {
    var state = getTransitionState(sectionEl);
    var target = state.activeTarget || getCurrentTarget(sectionEl);

    if (!target && fallbackToFirst) {
      var firstTab = sectionEl.querySelector('.mt-case-display__tab');
      target = firstTab ? firstTab.dataset.target : null;
    }

    if (target) {
      state.activeTarget = target;
      setActivePanel(sectionEl, target);
    }
  }

  function bindUrlSync(sectionEl) {
    if (!sectionEl || sectionEl.__mcdUrlSyncBound) return;
    sectionEl.__mcdUrlSyncBound = true;
    if (!isCaseStudiesPage()) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        sectionEl.__mcdInView = true;
        updateUrlForSlug(findSlugByTarget(sectionEl, getCurrentTarget(sectionEl)), 'replace');
      });
    }, {
      threshold: 0.35
    });

    observer.observe(sectionEl);
    sectionEl.__mcdUrlObserver = observer;
  }

  function applyInitialUrlState(sectionEl) {
    if (!sectionEl || sectionEl.__mcdInitialUrlApplied) return;
    sectionEl.__mcdInitialUrlApplied = true;
    if (!isCaseStudiesPage()) return;

    var requestedSlug = getRequestedSlug();
    if (!requestedSlug) return;

    var tab = findTabBySlug(sectionEl, requestedSlug);
    if (!tab || !tab.dataset.target) return;

    getTransitionState(sectionEl).activeTarget = tab.dataset.target;
    setActivePanel(sectionEl, tab.dataset.target);

    window.requestAnimationFrame(function () {
      scrollSectionIntoView(sectionEl);
      updateUrlForSlug(requestedSlug, 'replace');
    });
  }

  function applyUrlStateWithoutScroll(sectionEl) {
    if (!sectionEl || !isCaseStudiesPage()) return;

    var requestedSlug = getRequestedSlug();
    if (!requestedSlug) return;

    var tab = findTabBySlug(sectionEl, requestedSlug);
    if (!tab || !tab.dataset.target) return;

    getTransitionState(sectionEl).activeTarget = tab.dataset.target;
    setActivePanel(sectionEl, tab.dataset.target);
  }

  function bindTransitionLifecycle(sectionEl) {
    if (!sectionEl || sectionEl.__mcdTransitionBound) return;
    sectionEl.__mcdTransitionBound = true;

    function clearRestoreState() {
      if (sectionEl.__mcdRestoreTimer) {
        window.clearTimeout(sectionEl.__mcdRestoreTimer);
        sectionEl.__mcdRestoreTimer = 0;
      }
      sectionEl.classList.remove('mt-case-display--transition-restoring');
    }

    sectionEl.addEventListener('mt:page-transition-freeze', function () {
      clearRestoreState();
      var state = getTransitionState(sectionEl);
      state.activeTarget = getCurrentTarget(sectionEl);
      sectionEl.classList.add('mt-case-display--transition-frozen');
      sectionEl.classList.remove('mt-case-display--transition-committed');
      syncTransitionTarget(sectionEl, true);
    });

    sectionEl.addEventListener('mt:page-transition-commit', function () {
      clearRestoreState();
      var state = getTransitionState(sectionEl);
      if (!state.activeTarget) {
        state.activeTarget = getCurrentTarget(sectionEl);
      }
      sectionEl.classList.remove('mt-case-display--transition-frozen');
      sectionEl.classList.add('mt-case-display--transition-committed');
      syncTransitionTarget(sectionEl, true);
    });

    sectionEl.addEventListener('mt:page-transition-reset', function () {
      var state = getTransitionState(sectionEl);
      if (!state.activeTarget) {
        state.activeTarget = getCurrentTarget(sectionEl);
      }
      clearRestoreState();
      sectionEl.classList.add('mt-case-display--transition-restoring');
      sectionEl.classList.remove('mt-case-display--transition-frozen');
      sectionEl.classList.remove('mt-case-display--transition-committed');
      syncTransitionTarget(sectionEl, true);
      sectionEl.__mcdRestoreTimer = window.setTimeout(function () {
        sectionEl.__mcdRestoreTimer = 0;
        sectionEl.classList.remove('mt-case-display--transition-restoring');
      }, 180);
    });

    sectionEl.addEventListener('mt:page-transition-destroy', function () {
      clearRestoreState();
      sectionEl.classList.remove('mt-case-display--transition-frozen');
      sectionEl.classList.remove('mt-case-display--transition-committed');
    });
  }

  /* ── Tab 切换 ── */
  function initCaseDisplay(sectionEl) {
    if (!sectionEl || sectionEl.__mcdTabsBound) return;
    sectionEl.__mcdTabsBound = true;

    var tabs = sectionEl.querySelectorAll('.mt-case-display__tab');

    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.target;
        getTransitionState(sectionEl).activeTarget = target;
        setActivePanel(sectionEl, target);
        if (sectionEl.__mcdInView) {
          updateUrlForSlug(tab.dataset.tabSlug, 'push');
        }
      });
    });
  }

  /* ── 多图弹窗逻辑 ── */
  function initModal(sectionEl) {
    if (!sectionEl || sectionEl.__mcdModalBound) return;
    sectionEl.__mcdModalBound = true;

    sectionEl.dataset.mcdRuntime = 'per-button-modal-v3';
    var sectionId = sectionEl.dataset.sectionId || '';
    var modalMap = new Map();
    var preloadedUrls = new Set();
    var openModalClosers = new Set();
    var uniqueCounter = 0;

    function safeParseImgs(imgsJson) {
      try {
        var parsed = JSON.parse(imgsJson || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function normalizeCardId(btn, idx) {
      var raw = (btn.dataset.mcdCard || '').trim();
      if (raw) return raw + '--' + String(idx + 1);
      uniqueCounter += 1;
      return 'auto-' + sectionId + '-' + uniqueCounter;
    }

    function preloadUrl(src) {
      if (!src || preloadedUrls.has(src)) return;
      preloadedUrls.add(src);
      var img = new Image();
      img.src = src;
    }

    function preloadPrimary(btn) {
      if (!btn || btn.dataset.mcdWarm === '1') return;
      btn.dataset.mcdWarm = '1';
      var imgs = safeParseImgs(btn.dataset.mcdImgs);
      if (imgs[0] && imgs[0].src) preloadUrl(imgs[0].src);
      if (imgs[1] && imgs[1].src) preloadUrl(imgs[1].src);
    }

    function getPayload(btn) {
      return {
        imgs: safeParseImgs(btn.dataset.mcdImgs),
        name: btn.dataset.mcdName || '',
        showcaseSrc: btn.dataset.mcdShowcase || '',
        showcasePos: btn.dataset.mcdShowcasePos || '8',
        splitSrc: btn.dataset.mcdSplitScroll || '',
        splitPos: btn.dataset.mcdSplitPos || '8',
        splitSide: btn.dataset.mcdSplitSide || '',
        bannerBg: btn.dataset.mcdBannerBg || '#50B5E7',
        bannerTextColor: btn.dataset.mcdBannerTextColor || '#FFFFFF',
        bannerArrowColor: btn.dataset.mcdBannerArrowColor || '#1A2E54',
        borderColor: btn.dataset.mcdBorderColor || '#50B5E7',
        closeBgColor: btn.dataset.mcdCloseBgColor || '#50B5E7',
        closeIconColor: btn.dataset.mcdCloseIconColor || '#1A2E54'
      };
    }

    function createModalContext(cardId, payload) {
      var modal = document.createElement('div');
      modal.className = 'mcd-modal';
      modal.id = 'mcd-modal-' + sectionId + '-' + cardId;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', '案例详情');
      modal.setAttribute('hidden', '');
      modal.style.setProperty('--mcd-modal-banner-bg', payload.bannerBg || '#50B5E7');
      modal.style.setProperty('--mcd-modal-banner-text-color', payload.bannerTextColor || '#FFFFFF');
      modal.style.setProperty('--mcd-modal-banner-arrow-color', payload.bannerArrowColor || '#1A2E54');
      modal.style.setProperty('--mcd-modal-border-color', payload.borderColor || '#50B5E7');
      modal.style.setProperty('--mcd-modal-close-bg-color', payload.closeBgColor || '#50B5E7');
      modal.style.setProperty('--mcd-modal-close-icon-color', payload.closeIconColor || '#1A2E54');
      modal.innerHTML = '' +
        '<div class="mcd-modal__backdrop"></div>' +
        '<div class="mcd-modal__box">' +
        '<button class="mcd-modal__close" type="button" aria-label="关闭">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>' +
        '</svg>' +
        '</button>' +
        '<div class="mcd-modal__img-wrap">' +
        '<div class="mcd-modal__banner" role="button" tabindex="0" aria-label="关闭弹窗">' +
        '<span class="mcd-modal__banner-text">CLICK TO RETURN</span>' +
        '<span class="mcd-modal__banner-arrow" aria-hidden="true">' +
        '<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M70.8327 70.8346L29.166 29.168" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '<path d="M29.166 70.8346V29.168H70.8327" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '</div>';
      sectionEl.appendChild(modal);

      var imgWrap = modal.querySelector('.mcd-modal__img-wrap');
      var closeBtn = modal.querySelector('.mcd-modal__close');
      var backdrop = modal.querySelector('.mcd-modal__backdrop');
      var banner = modal.querySelector('.mcd-modal__banner');

      var state = {
        activeSessionId: 0,
        lazyLoaded: false,
        hoverWarmed: false,
        imgEls: [],
        showcaseWrap: null,
        showcaseImg: null,
        splitScrollWrap: null,
        splitScrollImg: null,
        splitSideImg: null,
        showcaseReady: false,
        splitReady: false,
        showcaseObserver: null,
        splitObserver: null
      };

      function isSessionStale(sessionId) {
        return sessionId !== state.activeSessionId;
      }

      function resetShowcaseImageState(imgEl) {
        if (!imgEl) return;
        imgEl.onload = null;
        imgEl.style.animation = 'none';
        imgEl.style.transform = 'translateY(0)';
        imgEl.style.removeProperty('--mcd-scroll-end');
        imgEl.style.removeProperty('--mcd-scroll-duration');
        void imgEl.offsetHeight;
      }

      function resetScrollState() {
        resetShowcaseImageState(state.showcaseImg);
        resetShowcaseImageState(state.splitScrollImg);
      }

      function disconnectObservers() {
        if (state.showcaseObserver) {
          state.showcaseObserver.disconnect();
          state.showcaseObserver = null;
        }
        if (state.splitObserver) {
          state.splitObserver.disconnect();
          state.splitObserver = null;
        }
      }

      function renderWithBlocks(imgEls, blocks) {
        var count = imgEls.length;
        var slots = blocks.map(function (b) {
          var p = parseInt(b.pos, 10);
          if (isNaN(p) || p >= count) return { el: b.el, at: count };
          if (p <= 0) return { el: b.el, at: 0 };
          return { el: b.el, at: p };
        });
        slots.sort(function (a, b) { return a.at - b.at; });

        var ref = banner || null;
        var slotIdx = 0;
        while (slotIdx < slots.length && slots[slotIdx].at === 0) {
          imgWrap.insertBefore(slots[slotIdx].el, ref);
          slotIdx++;
        }
        for (var i = 0; i < count; i++) {
          imgWrap.insertBefore(imgEls[i], ref);
          while (slotIdx < slots.length && slots[slotIdx].at === i + 1) {
            imgWrap.insertBefore(slots[slotIdx].el, ref);
            slotIdx++;
          }
        }
        while (slotIdx < slots.length) {
          imgWrap.insertBefore(slots[slotIdx].el, ref);
          slotIdx++;
        }
      }

      function startShowcaseScroll(sessionId) {
        if (isSessionStale(sessionId) || !state.showcaseWrap || !state.showcaseImg) return;
        var containerH = state.showcaseWrap.offsetHeight;
        var imgH = state.showcaseImg.offsetHeight;
        if (!imgH || imgH <= containerH) {
          state.showcaseImg.style.animation = 'none';
          state.showcaseImg.style.transform = 'translateY(0)';
          return;
        }
        var scrollDist = imgH - containerH;
        var pct = (scrollDist / imgH) * 100;
        var duration = Math.max(5.3, scrollDist / 75);
        state.showcaseImg.style.setProperty('--mcd-scroll-end', '-' + pct.toFixed(2) + '%');
        state.showcaseImg.style.setProperty('--mcd-scroll-duration', duration.toFixed(1) + 's');
        state.showcaseImg.style.animation = 'none';
        void state.showcaseImg.offsetHeight;
        state.showcaseImg.style.animation = '';
      }

      function startSplitScroll(sessionId) {
        if (isSessionStale(sessionId) || !state.splitScrollWrap || !state.splitScrollImg) return;
        var containerH = state.splitScrollWrap.offsetHeight;
        var imgH = state.splitScrollImg.offsetHeight;
        if (!imgH || imgH <= containerH) {
          state.splitScrollImg.style.animation = 'none';
          state.splitScrollImg.style.transform = 'translateY(0)';
          return;
        }
        var scrollDist = imgH - containerH;
        var pct = (scrollDist / imgH) * 100;
        var duration = Math.max(5.3, scrollDist / 75);
        state.splitScrollImg.style.setProperty('--mcd-scroll-end', '-' + pct.toFixed(2) + '%');
        state.splitScrollImg.style.setProperty('--mcd-scroll-duration', duration.toFixed(1) + 's');
        state.splitScrollImg.style.animation = 'none';
        void state.splitScrollImg.offsetHeight;
        state.splitScrollImg.style.animation = '';
      }

      function buildStaticContent() {
        var imgEls = payload.imgs.map(function (item, idx) {
          var el = document.createElement('img');
          el.className = 'mcd-modal__img';
          el.alt = item.alt || payload.name || '';
          el.loading = 'lazy';
          if (idx <= 1) {
            el.src = item.src || '';
          } else {
            el.dataset.src = item.src || '';
          }
          return el;
        });
        state.imgEls = imgEls;

        var blocks = [];

        if (payload.splitSrc) {
          var splitWrapper = document.createElement('div');
          splitWrapper.className = 'mcd-modal__showcase-outer mcd-modal__showcase-outer--split';
          var splitOuter = document.createElement('div');
          splitOuter.className = 'mcd-modal__showcase-split';
          var splitLeft = document.createElement('div');
          splitLeft.className = 'mcd-modal__showcase-split__left';
          var splitScrollWrap = document.createElement('div');
          splitScrollWrap.className = 'mcd-modal__showcase';
          var splitScrollImg = document.createElement('img');
          splitScrollImg.className = 'mcd-modal__showcase-img';
          splitScrollImg.alt = payload.name || '';
          splitScrollWrap.appendChild(splitScrollImg);
          splitLeft.appendChild(splitScrollWrap);
          var splitRight = document.createElement('div');
          splitRight.className = 'mcd-modal__showcase-split__right';
          var splitSideImg = document.createElement('img');
          splitSideImg.className = 'mcd-modal__showcase-split__img';
          splitSideImg.alt = payload.name || '';
          splitSideImg.loading = 'lazy';
          splitRight.appendChild(splitSideImg);
          splitOuter.appendChild(splitLeft);
          splitOuter.appendChild(splitRight);
          splitWrapper.appendChild(splitOuter);

          state.splitScrollWrap = splitScrollWrap;
          state.splitScrollImg = splitScrollImg;
          state.splitSideImg = splitSideImg;
          blocks.push({ el: splitWrapper, pos: payload.splitPos });
        }

        if (payload.showcaseSrc) {
          var showcaseOuter = document.createElement('div');
          showcaseOuter.className = 'mcd-modal__showcase-outer';
          var showcaseWrap = document.createElement('div');
          showcaseWrap.className = 'mcd-modal__showcase';
          var showcaseImg = document.createElement('img');
          showcaseImg.className = 'mcd-modal__showcase-img';
          showcaseImg.alt = payload.name || '';
          showcaseWrap.appendChild(showcaseImg);
          showcaseOuter.appendChild(showcaseWrap);

          state.showcaseWrap = showcaseWrap;
          state.showcaseImg = showcaseImg;
          blocks.push({ el: showcaseOuter, pos: payload.showcasePos });
        }

        if (blocks.length > 0) {
          renderWithBlocks(imgEls, blocks);
        } else {
          var ref = banner || null;
          imgEls.forEach(function (el) { imgWrap.insertBefore(el, ref); });
        }
      }

      function preloadFirstTwo() {
        if (payload.imgs[0] && payload.imgs[0].src) preloadUrl(payload.imgs[0].src);
        if (payload.imgs[1] && payload.imgs[1].src) preloadUrl(payload.imgs[1].src);
      }

      function preloadHoverResources() {
        if (state.hoverWarmed) return;
        state.hoverWarmed = true;

        if (payload.showcaseSrc) preloadUrl(payload.showcaseSrc);
        if (payload.splitSrc) preloadUrl(payload.splitSrc);
        if (payload.splitSide) preloadUrl(payload.splitSide);

        payload.imgs.forEach(function (item, idx) {
          if (idx <= 1) return;
          if (item && item.src) preloadUrl(item.src);
        });
      }

      function preloadShowcaseAndSplit() {
        if (payload.showcaseSrc) preloadUrl(payload.showcaseSrc);
        if (payload.splitSrc) preloadUrl(payload.splitSrc);
        if (payload.splitSide) preloadUrl(payload.splitSide);
      }

      function observeWhenVisible(targetEl, observerKey, onVisible) {
        if (!targetEl) return;
        if (state[observerKey]) return;

        if (typeof window.IntersectionObserver !== 'function') {
          onVisible();
          return;
        }

        var observer = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            if (state[observerKey] === observer) state[observerKey] = null;
            onVisible();
          });
        }, {
          root: imgWrap,
          threshold: 0.15
        });

        observer.observe(targetEl);
        state[observerKey] = observer;
      }

      function armScrollWhenVisible(sessionId) {
        if (isSessionStale(sessionId)) return;

        if (state.showcaseReady && state.showcaseWrap && state.showcaseImg) {
          observeWhenVisible(state.showcaseWrap, 'showcaseObserver', function () {
            startShowcaseScroll(sessionId);
          });
        }

        if (state.splitReady && state.splitScrollWrap && state.splitScrollImg) {
          observeWhenVisible(state.splitScrollWrap, 'splitObserver', function () {
            startSplitScroll(sessionId);
          });
        }
      }

      function lazyLoadRemaining(sessionId) {
        if (isSessionStale(sessionId) || state.lazyLoaded) return;
        state.lazyLoaded = true;

        state.imgEls.forEach(function (el, idx) {
          if (idx <= 1) return;
          if (el.dataset.src && !el.src) {
            el.src = el.dataset.src;
            el.removeAttribute('data-src');
          }
        });

        if (payload.splitSrc && state.splitScrollImg && state.splitSideImg) {
          state.splitScrollImg.src = payload.splitSrc;
          state.splitSideImg.src = payload.splitSide || '';
          if (state.splitScrollImg.complete && state.splitScrollImg.naturalHeight) {
            state.splitReady = true;
            armScrollWhenVisible(sessionId);
          } else {
            state.splitScrollImg.onload = function () {
              state.splitReady = true;
              armScrollWhenVisible(sessionId);
            };
          }
        }

        if (payload.showcaseSrc && state.showcaseImg) {
          state.showcaseImg.src = payload.showcaseSrc;
          if (state.showcaseImg.complete && state.showcaseImg.naturalHeight) {
            state.showcaseReady = true;
            armScrollWhenVisible(sessionId);
          } else {
            state.showcaseImg.onload = function () {
              state.showcaseReady = true;
              armScrollWhenVisible(sessionId);
            };
          }
        }
      }

      function open() {
        state.activeSessionId += 1;
        var sessionId = state.activeSessionId;
        resetScrollState();
        disconnectObservers();
        imgWrap.scrollTop = 0;
        modal.removeAttribute('hidden');
        openModalClosers.add(close);
        document.body.style.overflow = 'hidden';
        closeBtn.focus();

        preloadShowcaseAndSplit();
        armScrollWhenVisible(sessionId);

        window.setTimeout(function () {
          lazyLoadRemaining(sessionId);
        }, 0);
      }

      function close() {
        state.activeSessionId += 1;
        modal.setAttribute('hidden', '');
        openModalClosers.delete(close);
        if (openModalClosers.size === 0) {
          document.body.style.overflow = '';
        }
        disconnectObservers();
        resetScrollState();
      }

      buildStaticContent();
      preloadFirstTwo();

      closeBtn.addEventListener('click', close);
      backdrop.addEventListener('click', close);
      if (banner) {
        banner.addEventListener('click', close);
        banner.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            close();
          }
        });
      }

      return {
        open: open,
        close: close,
        preloadHoverResources: preloadHoverResources
      };
    }

    function getClosestFromEventTarget(target, selector) {
      if (!target) return null;
      var el = target.nodeType === 1 ? target : target.parentElement;
      if (!el || !el.closest) return null;
      return el.closest(selector);
    }

    function openByButton(btn) {
      if (!btn) return;
      var cardId = btn.dataset.mcdUid || '';
      var ctx = modalMap.get(cardId);
      if (!ctx) return;
      preloadPrimary(btn);
      ctx.open();
    }

    function warmByButton(btn) {
      if (!btn) return;
      preloadPrimary(btn);
      var cardId = btn.dataset.mcdUid || '';
      var ctx = modalMap.get(cardId);
      if (ctx && ctx.preloadHoverResources) {
        ctx.preloadHoverResources();
      }
    }

    var triggerButtons = sectionEl.querySelectorAll('[data-mcd-modal]');
    triggerButtons.forEach(function (btn, idx) {
      var cardId = normalizeCardId(btn, idx);
      btn.dataset.mcdUid = cardId;
      if (!modalMap.has(cardId)) {
        modalMap.set(cardId, createModalContext(cardId, getPayload(btn)));
      }
    });
    triggerButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openByButton(btn);
      });
    });

    sectionEl.addEventListener('click', function (e) {
      var btn = getClosestFromEventTarget(e.target, '[data-mcd-modal]');
      var cardWrap = getClosestFromEventTarget(e.target, '.mcd-card__wrap');
      var cardImg = getClosestFromEventTarget(e.target, '.mcd-card__img');
      var cardName = getClosestFromEventTarget(e.target, '.mcd-card__name');

      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        openByButton(btn);
        return;
      }

      if ((cardImg || cardName) && cardWrap) {
        var viewBtn = cardWrap.querySelector('[data-mcd-modal]');
        if (viewBtn) {
          e.preventDefault();
          e.stopPropagation();
          openByButton(viewBtn);
        }
      }
    });

    sectionEl.addEventListener('mouseover', function (e) {
      var btn = getClosestFromEventTarget(e.target, '[data-mcd-modal]');
      if (btn) warmByButton(btn);
    });

    sectionEl.addEventListener('focusin', function (e) {
      var btn = getClosestFromEventTarget(e.target, '[data-mcd-modal]');
      if (btn) warmByButton(btn);
    });

    sectionEl.addEventListener('touchstart', function (e) {
      var btn = getClosestFromEventTarget(e.target, '[data-mcd-modal]');
      if (btn) warmByButton(btn);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      openModalClosers.forEach(function (closeModalFn) {
        closeModalFn();
      });
      openModalClosers.clear();
      document.body.style.overflow = '';
    });
  }

  /* ── 初始化所有 section ── */
  function initSection(sectionEl) {
    if (!sectionEl) return;

    initCaseDisplay(sectionEl);
    initModal(sectionEl);
    bindTransitionLifecycle(sectionEl);
    bindUrlSync(sectionEl);
    syncTransitionTarget(sectionEl, true);
    applyInitialUrlState(sectionEl);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.mt-case-display').forEach(function (el) {
      initSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('popstate', function () {
    if (!isCaseStudiesPage()) return;
    document.querySelectorAll('.mt-case-display').forEach(function (el) {
      applyUrlStateWithoutScroll(el);
    });
  });
})();
